import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useUrlQuery } from '../utils/hooks';
import { navigateToPortal } from '../utils/utils';

const BillingPortal = () => {
  const { teamId } = useParams();
  const queryParams = useUrlQuery();

  const continueUrl =
    queryParams.get('continueUrl') ||
    `${window.location.origin}/app/team/${teamId}/farms`;

  useEffect(() => {
    navigateToPortal({
      teamId,
      continueUrl,
      replace: true,
    });
  });
  return null;
};

export default BillingPortal;
